module.exports = __webpack_public_path__ + "static/7-1afe22ba1cd71262dc7bda2eac91676e.png";